/**
 * ProDesignProjects Queries
 */

import gql from 'graphql-tag'

export const getProductsCompareQuery = gql`
  query getProductsCompare(
    $ids: [Int],
    $fromStore: Boolean,
    $category: String,
    $sport: Int,
    $inlineOnly: Boolean
  ) {
    products: getProductsCompare(
      ids: $ids,
      fromStore: $fromStore,
      category: $category,
      sport: $sport,
      inlineOnly: $inlineOnly
    ) {
      id
      name
      code
      chart
      description
      contentTile: content_tile
      relatedItemTag: team_name
      teamStoreItemId: related_item_tag
      descriptionRich: description_rich
      shortDescription: short_description
      season
      details
      defaultFit: default_fit
      hideFitStyles: hide_fit_styles
      materials: materials_info
      sizeRangeLabel: size_range_label
      weight
      yotpoAverageScore {
        total: total_reviews
        averageScore: average_score
      }
      bannerMaterials: banner_materials {
        id
        url
      }
      sports {
        id
        name
      }
      priceRange {
        price
        quantity
        abbreviation
        shortName: short_name
      }
      upgradeOne: upgrade_one {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeTwo: upgrade_two {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeThree: upgrade_three {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      fitStyles {
        id
        name: description
        info
      }
      images: original_pictures {
        front: front_image
        back: back_image
        left: left_image
        right: right_image
        genderId: gender_id
        colorId: color_id
        thumbnail
        preview
        color_id
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ComparisonEngine/data.ts